import { Provider } from 'react-redux';
import { SkeletonTheme } from 'react-loading-skeleton';
import { WagmiConfig } from 'wagmi';
import { store } from './store/createStore';
import Authlogic from './Authlogic';
import { getConfig } from './helpers/getLibrary';
import { WalletProvider } from './wallet/walletContext';

import 'react-loading-skeleton/dist/skeleton.css';

const App = () => {
  return (
    <Provider store={store}>
      <WagmiConfig config={getConfig()}>
        <WalletProvider>
          <SkeletonTheme
            baseColor='var(--grey-700-50)'
            highlightColor='var(--grey-700-50)'
          >
            <Authlogic />
          </SkeletonTheme>
        </WalletProvider>
      </WagmiConfig>
    </Provider>
  );
};

export default App;
